import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post("/driver-accounting/bulk-update-payout-hold", payload);
  },
  uploadAck(payload) {
    return Api.put("/driver-accounting/bulk-update-payout-hold", payload);
  },
};
